var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "magic_wand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.152 21.807l0.732 1.5 1.66 0.23-1.197 1.16 0.287 1.645-1.482-0.77-1.463 0.77 0.285-1.645-1.196-1.16 1.641-0.23 0.733-1.5zM5.757 12.827l1.037 2.090 2.301 0.338-1.66 1.625 0.395 2.285-2.072-1.072-2.053 1.072 0.393-2.285-1.66-1.625 2.303-0.338 1.018-2.090zM7.222 26.538l0.518 1.055 1.16 0.16-0.84 0.82 0.197 1.16-1.035-0.553-1.053 0.553 0.195-1.16-0.84-0.82 1.16-0.16 0.537-1.055zM31.197 7.096l-19.352 21.548c-0.055 0.055-0.125 0.055-0.16 0.020l-5.195-4.68c-0.035-0.035-0.055-0.105 0-0.141l19.352-21.549c0.035-0.036 0.109-0.036 0.145 0l5.195 4.659c0.051 0.035 0.051 0.107 0.016 0.142zM14.203 16.843l-6.158 6.84c-0.037 0.035-0.037 0.106 0.016 0.141l3.625 3.25c0.035 0.055 0.107 0.035 0.143 0l6.143-6.836c0.035-0.055 0.035-0.127 0-0.162l-3.625-3.248c-0.035-0.037-0.108-0.037-0.143 0.016z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityMagicWand);
export default __webpack_public_path__ + "static/media/unity_magic_wand.95f792d01c0243d51ed41cf340e5ac8a.svg";
export { ForwardRef as ReactComponent };